import { Clock3 } from "lucide-react";
import { formatDateTime, relativeTime } from "@/lib/format";

/**
 * What the last chase list actually did.
 *
 * A quiet day is not a failure - the email deliberately stays away when there
 * is nothing to chase - so it gets said in words rather than looking like a
 * zero.
 */
const lastSentNote = (last) => {
  if (!last?.sent_at) return "No chase list has gone out yet";
  if (last.skipped) return "Nothing to chase that day";
  const leads = `${last.total} lead${last.total === 1 ? "" : "s"}`;
  return `${leads} · ${formatDateTime(last.sent_at)}`;
};

/** When the chase list goes out, to whom, and when it last went. */
export const DigestScheduleTiles = ({ schedule, last }) => (
  <dl className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-3">
    <div className="rounded-lg border border-border bg-[color:var(--tt-surface-2)] px-4 py-3">
      <dt className="text-[10px] font-bold uppercase tracking-[0.12em] text-primary">
        Chase list goes out
      </dt>
      <dd data-testid="email-panel-schedule" className="mt-1 text-sm font-bold text-foreground">
        {schedule.send_time_label || "—"}
      </dd>
      <dd className="mt-0.5 flex items-center gap-1 text-[11px] text-muted-foreground">
        <Clock3 className="h-3 w-3" aria-hidden="true" />
        next {schedule.next_send_label || "—"}
      </dd>
    </div>
    <div className="rounded-lg border border-border bg-[color:var(--tt-surface-2)] px-4 py-3">
      <dt className="text-[10px] font-bold uppercase tracking-[0.12em] text-primary">Goes to</dt>
      <dd
        data-testid="email-panel-recipients"
        className="mt-1 break-words text-sm font-bold text-foreground"
      >
        {(schedule.recipients || []).join(", ") || "Nobody set"}
      </dd>
      <dd className="mt-0.5 text-[11px] text-muted-foreground">
        Stays quiet on days with nothing to chase
      </dd>
    </div>
    <div className="rounded-lg border border-border bg-[color:var(--tt-surface-2)] px-4 py-3">
      <dt className="text-[10px] font-bold uppercase tracking-[0.12em] text-primary">
        Last sent
      </dt>
      <dd data-testid="email-panel-last" className="mt-1 text-sm font-bold text-foreground">
        {last?.sent_at ? relativeTime(last.sent_at) : "Never"}
      </dd>
      <dd className="mt-0.5 text-[11px] text-muted-foreground">{lastSentNote(last)}</dd>
    </div>
  </dl>
);
